export const CANCELLATION_TYPES = {
  CLIENT: 'client',
  STAFF: 'staff',
  OTHER: 'other',
};

/**
 * Appointment types that are not a service delivered to a client: a block on the calendar, not a
 * visit. Both can still have a client set — an unavailability can mark the client's own day off.
 * @type {AppointmentType[]}
 */
export const NON_CLIENT_APPOINTMENT_TYPES = ['unavailability', 'staffEvent'];

/**
 * Statuses an appointment can be cancelled from.
 *
 * Also the full value domain of `statusBeforeCancel`, which is only ever written as the status
 * being left behind — so that field never holds `completed`, `rendered` or `deleted`, even though
 * the Postgres enum mirroring it is the wider appointment-status one.
 */
export const CANCELLABLE_STATUSES = ['created', 'draft', 'scheduled'];

/**
 * Copied onto the session activity's `appointmentData` when an appointment is linked. The
 * integration sync reads them from the activity, not from the appointment.
 */
export const APPOINTMENT_INTEGRATION_FIELDS = [
  'integrationReference',
  'integrationClientParRef',
  'integrationStaffParRef',
  'integrationClientRef',
  'integrationStaffRef',
  'integrationAppointmentType',
  'integration',
  'integrationExternalUrl',
];
